// @flow
import * as React from 'react'
import { List, Empty } from 'antd'
import { injectIntl } from 'react-intl'
import ListingItem from '../ListingItem'
import './index.css'

type Props = {
  events: Array<Event>,
  intl: any,
}

const Listing = ({ events, intl }: Props) => (
  <React.Fragment>
    {events.length > 0 ? (
      <List
        itemLayout="horizontal"
        size="large"
        pagination={{
          pageSize: 25,
          size: 'small',
          hideOnSinglePage: true,
        }}
        dataSource={events}
        renderItem={item => (
          <List.Item key={item.UID}>
            <ListingItem event={item} />
          </List.Item>
        )}
      />
    ) : (
      <Empty
        style={{
          height: 'calc(100vh - 10rem)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          color: '#666',
        }}
        image={Empty.PRESENTED_IMAGE_DEFAULT}
        description={intl.formatMessage({
          id: 'listing.noresults',
          defaultMessage: 'No results',
        })}
      />
    )}
  </React.Fragment>
)

Listing.defaultProps = {
  events: [],
}

export default React.memo<Props>(injectIntl(Listing))
